// The sting before frame 0 of the season timelapse (R1655, brand.md §11,
// ui-map-interface.md §3.6).
//
// The player runs the sting's clock (`TimelapsePlayer.intro`); this file
// draws it. One `IntroSting` follows one player: while the intro runs it
// keeps a sting canvas over the map of its view, on a veil of the deep
// water, and draws the frame of the intro's time at every step of the
// player. A tap on the canvas skips the sting. When the intro ends, the
// canvas goes, and frame 0 stands under it.
//
// Under reduced motion the canvas shows the last frame of the sting for
// the length of the intro.

import { reducedMotion } from '../../render/motion';
import { STING_LAST_SEC, StingLayer, chromeStingStyle } from '../sting';
import type { TimelapsePlayer } from './player';

export class IntroSting {
  private layer: StingLayer | null = null;

  /** `host` answers the element the canvas fills: it must be a positioned
   *  box. A view whose markup can be rebuilt answers the element of now. */
  constructor(
    private readonly player: TimelapsePlayer,
    private readonly host: () => HTMLElement | null,
    private readonly still: () => boolean = reducedMotion,
  ) {}

  /** True while the sting stands over the map. */
  get shown(): boolean { return this.layer !== null; }

  /** Follows the player: called at every change it emits. */
  update(): void {
    const t = this.player.intro;
    if (t < 0) {
      this.drop();
      return;
    }
    const host = this.host();
    if (!host) return;
    if (this.layer && this.layer.el.parentElement !== host) this.drop();
    if (!this.layer) {
      // The accent is the one the chrome wears when the sting starts.
      this.layer = new StingLayer(chromeStingStyle(true, 'fade'), () => this.player.skipIntro());
      host.appendChild(this.layer.el);
    }
    this.layer.draw(this.still() ? STING_LAST_SEC : t);
  }

  /** Takes the canvas away. */
  drop(): void {
    this.layer?.remove();
    this.layer = null;
  }
}
